import Vue from "vue";
const templateId = +document.body.getAttribute("tplid") || document.body.getAttribute("data-tplid");
const templatePath = "./templates/" + templateId + "/statusrazdel.js";

let component = Vue.component("statusrazdel", function(resolve, reject) {
  import(`${templatePath}`).then(res => {
    resolve({
      template: res.default,
      props: ['sp','jsonval'],
      methods: {
        clickSp() {
          this.$emit('putSpToApp')
        },
        clickAfterSp() {
          this.$emit('putSpToApp');
          this.$emit('spvalue');
          this.aftersp = true;
          this.beforesp = false;
        },
        f() {
          this.isAct=!this.isAct;
          this.$emit('fstatus');
        }
      },
      data() {
        return {
          templateId:templateId,
          isAct: true,
          aftersp: false,
          beforesp: true
        }
      },
      computed:{
        caretfup(){
          if(this.templateId>37) return 'fa fa-caret-square-o-up'
          return this.templateId==36 || this.templateId==37 ? 'fa fa-minus-square' : 'fa fa-caret-up'
        },
        caretfdn(){
          if(this.templateId>37) return 'fa fa-caret-square-o-down'
          return this.templateId==36 || this.templateId==37 ? 'fa fa-plus-square' : 'fa fa-caret-down'
        },
      },
      watch: {
        'beforesp': function () {
          let x = window.location.href
          if (x.indexOf('group_id=') === -1) {
            if (!this.sp) {
              this.aftersp = false
              this.beforesp = true
              this.$emit('spvalue')
            }
          }
        }
      },
      mounted() {
        if (typeof this.sp === undefined) {
          this.aftersp = false
          this.beforesp = true
          this.$emit('spvalue')
        }
        let x = window.location.href
        if (x.indexOf('findtext=') > 0) {
          this.beforesp = false
          this.aftersp = true
        }
      }
    });
  });
});
export default component;



// WEBPACK FOOTER //
// ./src/components/statusrazdel.js